import moment from 'moment/moment';

// Checks if date has passed
export function isBeforeNow(date: Date) {
	return moment(date).toDate() < moment(new Date()).toDate();
}
